/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const Context = createContext(undefined);
Context.displayName = 'MenuContext';